<template>
  <svg
    aria-hidden="true"
    ...attributes
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1707 2.94739H7.40835C6.57243 2.94739 5.89478 3.64924 5.89478 4.51502V13.5903C5.89478 14.4561 6.57243 15.1579 7.40835 15.1579H16.1707C17.0066 15.1579 17.6842 14.4561 17.6842 13.5903V4.51502C17.6842 3.64924 17.0066 2.94739 16.1707 2.94739Z"
      stroke="currentColor"
      stroke-width="1.5"
    ></path>
    <path
      d="M19.4851 6.3158H10.4098C9.54402 6.3158 8.84216 6.99345 8.84216 7.82937V16.5917C8.84216 17.4276 9.54402 18.1053 10.4098 18.1053H19.4851C20.3508 18.1053 21.0527 17.4276 21.0527 16.5917V7.82937C21.0527 6.99345 20.3508 6.3158 19.4851 6.3158Z"
      stroke="currentColor"
      stroke-width="1.5"
    ></path>
    <path
      d="M13.5903 8.8421H4.51502C3.64924 8.8421 2.94739 9.54395 2.94739 10.4097V19.485C2.94739 20.3508 3.64924 21.0526 4.51502 21.0526H13.5903C14.4561 21.0526 15.1579 20.3508 15.1579 19.485V10.4097C15.1579 9.54395 14.4561 8.8421 13.5903 8.8421Z"
      stroke="currentColor"
      stroke-width="1.5"
    ></path>
  </svg>
</template>
